var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react';
import ECGAndPPGStrips from '../../components/ecg-ppg-strips';
import PersonalInfoBox from '../../components/personal-info-box';
import ReportHeader from '../../components/report-header';
import { drawAppendEcgChart } from '@cardiacsense/cs-charts-module';
import { REPORT_TYPES, RT_END_STATUS, dateFormats, print_width } from '../../consts';
import moment from 'moment';
import { fakeEcgDataForProportionSign } from '../../utils/general-utils';
import { formatEcgPpgData, getRealTimeRecordingTime } from '../../utils/ecg-ppg-utils';
import ReportFooter from '../../components/footer-report';
import '../../css/reports.css';
import RtDetailes from '../../components/rt-details';
import { useWindowSize } from '../../hooks/useOnResize';
import { t } from '../../multi-language/multi-lang.service';
import useChangeLanguage from '../../hooks/useChangeLanguage';
export default function RealtimeReportComponent(_a) {
    var data = _a.data, isPdf = _a.isPdf, width = _a.width;
    var refToPrint = useRef(null);
    console.log('ALL DATA', data);
    var patient = data.patientProfile, patientQuestions = data.patientQuestions, questionsScore = data.questionsScore, af_detection_summary_data = data.af_detection_summary_data, ecg_ppg = data.ecg_ppg, statusRtEnd = data.statusRtEnd, medications = data.medications, appConfiguration = data.appConfiguration;
    var _b = useChangeLanguage(patient === null || patient === void 0 ? void 0 : patient.language), isSelectedLanguage = _b.isSelectedLanguage, isRTL = _b.isRTL;
    width = width || window.innerWidth - window.innerWidth / 15;
    var isAf = statusRtEnd === RT_END_STATUS.STOPPED_ECG_AF_DETECTED;
    var isDocStopped = statusRtEnd === RT_END_STATUS.STOPPED_BY_DOCTOR;
    var formattedData = formatEcgPpgData(ecg_ppg);
    var getRTRecordingTime = function () {
        var _a, _b;
        var start = (_a = ecg_ppg[0]) === null || _a === void 0 ? void 0 : _a.timestamp;
        var end = (_b = ecg_ppg[ecg_ppg.length - 1]) === null || _b === void 0 ? void 0 : _b.timestamp;
        var record = getRealTimeRecordingTime(start, end, dateFormats.tz);
        return record;
    };
    var record = getRTRecordingTime();
    var windowWidth = useWindowSize()[0];
    useEffect(function () {
        if (!isSelectedLanguage)
            return;
        drawEcgCharts(patient.fwVersion);
        console.log('windowWidth', windowWidth);
    }, [windowWidth, isSelectedLanguage]);
    var drawEcgCharts = function (fwVersion) {
        console.log('draw again');
        var charts = { "ecg-report-chart": { draw: drawAppendEcgChart, data: [formattedData] } };
        Object.keys(charts).forEach(function (type) {
            var _a, _b, _c, _d, _e, _f, _g;
            var _h = charts[type], draw = _h.draw, data = _h.data;
            if (type === 'ecg-report-chart') {
                //this inject fake data for drawing a proportion sign
                ((_e = (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.ecg_ppg) === null || _b === void 0 ? void 0 : _b.ecg_ppg_strips_sorted) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.strips) === null || _e === void 0 ? void 0 : _e[0]) &&
                    (data[0].ecg_ppg.ecg_ppg_strips_sorted[0].strips[0] =
                        fakeEcgDataForProportionSign(1, fwVersion));
            }
            var chartNode = document.getElementsByClassName("".concat(type))[0];
            var height = width / 4; //isPdf ? pdf_chart_height : chart_height
            var chartSVG = draw.apply(void 0, __spreadArray(__spreadArray([t], data, false), [{},
                function (date) { return window.open("/static/reports/af-report/".concat(moment(date).format('YYYY-MM-DD')), "_blank"); },
                width,
                height,
                type,
                false,
                fwVersion], false));
            // draw the same chart beat smaller for printing in portal
            var chartSVGPrint;
            if (!isPdf) {
                chartSVGPrint = draw.apply(void 0, __spreadArray(__spreadArray([t], data, false), [{},
                    function (date) { return window.open("/static/reports/daily-report/".concat(moment(date).format('YYYY-MM-DD')), "_blank"); },
                    print_width,
                    print_width / 4,
                    type,
                    false,
                    fwVersion], false));
            }
            function isNode(e) {
                return (typeof Node === "object" ? e instanceof Node :
                    e && typeof e === "object" && typeof e.nodeType === "number" && typeof e.nodeName === "string");
            }
            if (chartSVG.length > 1) {
                if ((_f = chartNode.children) === null || _f === void 0 ? void 0 : _f.length)
                    chartNode.innerHTML = ''; //avoid duplications
                chartSVG.map(function (m, index, arr) {
                    if (isNode(m)) {
                        var wrapBrowserChart = document.createElement('div');
                        wrapBrowserChart.setAttribute('class', "".concat(!isPdf ? 'print-hide' : '', " pdf-cut-guard"));
                        wrapBrowserChart.appendChild(m);
                        chartNode === null || chartNode === void 0 ? void 0 : chartNode.appendChild(wrapBrowserChart);
                    }
                });
                if (chartSVGPrint) {
                    chartSVGPrint.map(function (m, index, arr) {
                        if (isNode(m)) {
                            var wrapPrintChart = document.createElement('div');
                            wrapPrintChart.setAttribute('class', 'print-show pdf-cut-guard');
                            wrapPrintChart.appendChild(m);
                            chartNode === null || chartNode === void 0 ? void 0 : chartNode.appendChild(wrapPrintChart);
                        }
                    });
                }
            }
            else {
                isNode(chartSVG) && !((_g = chartNode.children) === null || _g === void 0 ? void 0 : _g.length) && (chartNode === null || chartNode === void 0 ? void 0 : chartNode.appendChild(chartSVG));
            }
        });
    };
    if (!patient || !isSelectedLanguage)
        return React.createElement(React.Fragment, null);
    return (React.createElement("div", { ref: refToPrint, className: "wrap-report wrap-monthly-report wrap-realtime-report ".concat(isPdf ? 'is-pdf' : 'is-not-pdf', " ").concat(isRTL ? 'rtl' : 'ltr') },
        React.createElement(ReportHeader, { type: REPORT_TYPES.RT, user: patient, isPdf: false, startDate: record.startFormatted, refToPrint: refToPrint }),
        React.createElement(PersonalInfoBox, { user: patient, patientQuestions: patientQuestions, questionsScore: questionsScore, medications: medications, appConfig: appConfiguration }),
        React.createElement(RtDetailes, { record: record, isAf: isAf, isStopped: isDocStopped }),
        React.createElement("div", { className: 'ecg-report-chart ltr' },
            React.createElement(ECGAndPPGStrips, { af_detection_summary_data: af_detection_summary_data, rtDate: "09:28, 24 Oct 2022", isPdf: isPdf })),
        React.createElement(ReportFooter, null)));
}
//# sourceMappingURL=realtime-report.js.map